/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import ErrorLevel from '../error/error-level';
import SentrySeverity from './sentry-severity';

// TODO: Proč to je továrna a není to třída se statickou metodou nebo dokonce jen funkce?
/**
 * Továrna na úrovně chyb v Sentry API.
 */
class SentrySeverityFactory {
  /**
   * Vytvoří Sentry úroveň chyby z obecného číselníku chyb.
   * @param {ErrorLevel} errorLevel
   * @returns {SentrySeverity}
   */
  fromErrorLevel(errorLevel) {
    switch (errorLevel) {
      case ErrorLevel.Debug:
        return SentrySeverity.Debug;
      case ErrorLevel.Error:
        return SentrySeverity.Error;
      case ErrorLevel.Info:
        return SentrySeverity.Info;
      case ErrorLevel.Log:
        return SentrySeverity.Log;
      case ErrorLevel.Warning:
        return SentrySeverity.Warning;
      default:
        throw new RangeError(`Unknown error level "${errorLevel}".`);
    }
  }
}

export default SentrySeverityFactory;
